<template lang="pug">
div
  app-divider(label="Atividades", v-if="showListagem")
  app-collapse-child(
    title="Culturas permanentes",
    name="culturasPermanentes",
    v-if="destinacaoUsoImovel.culturasPermanentes && destinacaoUsoImovel.culturasPermanentes.length > 0"
    :class="compararDestinacaoUsoImovel && compararDestinacaoUsoImovel.mudouCulturaPermanente ? 'text-collapse': '' "
  )
    el-table(
      :data="destinacaoUsoImovel.culturasPermanentes",
    )
      template(slot="empty")
        | Nenhuma cultura permanente cadastrada.
      el-table-column(
        prop="descTipo",
        label="Tipo",
        :formatter="setTipoAtividadeProducao"
        :class="compararDestinacaoUsoImovel && compararDestinacaoUsoImovel.mudouCulturaPermanente && compararDestinacaoUsoImovel.mudouCulturaPermanente.mudouTipo ? 'text': '' "
      )
      el-table-column(
        prop="area",
        :label= "(isBahia ? 'Área estimada' : 'Área')"
        :formatter="formatAreaHectare"
        :class="compararDestinacaoUsoImovel && compararDestinacaoUsoImovel.mudouCulturaPermanente && compararDestinacaoUsoImovel.mudouCulturaPermanente.mudouArea ? 'text': '' "
      )
      el-table-column(
        v-if="produtividade"
        prop="produtividade",
        label="Produtividade",
        width="180",
        :formatter="formatProdutividade"
        :class="compararDestinacaoUsoImovel && compararDestinacaoUsoImovel.mudouCulturaPermanente && compararDestinacaoUsoImovel.mudouCulturaPermanente.mudouProdutividade ? 'text': '' "
      )

  app-collapse-child(
    title="Culturas temporárias",
    name="culturasTemporarias",
    v-if="destinacaoUsoImovel.culturasTemporarias && destinacaoUsoImovel.culturasTemporarias.length > 0"
    :class="compararDestinacaoUsoImovel && compararDestinacaoUsoImovel.mudouCulturaTemporaria ? 'text-collapse': '' "
  )
    el-table(
      :data="destinacaoUsoImovel.culturasTemporarias",
    )
      template(slot="empty")
        | Nenhuma cultura temporária cadastrada.
      el-table-column(
        prop="tipo",
        label="Tipo",
        :formatter="setTipoAtividadeProducao"
        :class="compararDestinacaoUsoImovel && compararDestinacaoUsoImovel.mudouCulturaTemporaria && compararDestinacaoUsoImovel.mudouCulturaTemporaria.mudouTipo ? 'text': '' "
      )
      el-table-column(
        prop="area",
        :label= "(isBahia ? 'Área estimada' : 'Área')"
        :formatter="formatAreaHectare"
        :class="compararDestinacaoUsoImovel && compararDestinacaoUsoImovel.mudouCulturaTemporaria && compararDestinacaoUsoImovel.mudouCulturaTemporaria.mudouArea ? 'text': '' "
      )
      el-table-column(
        v-if="produtividade"
        prop="produtividade",
        label="Produtividade",
        width="200",
        :formatter="formatProdutividade"
        :class="compararDestinacaoUsoImovel && compararDestinacaoUsoImovel.mudouCulturaTemporaria && compararDestinacaoUsoImovel.mudouCulturaTemporaria.mudouProdutividade ? 'text': '' "
      )
  app-collapse-child(
    title="Criações",
    name="criacoes",
    v-if="destinacaoUsoImovel.criacoes && destinacaoUsoImovel.criacoes.length > 0"
  )
    el-table(
      :data="destinacaoUsoImovel.criacoes",
    )
      template(slot="empty")
        | Nenhuma criação cadastrada.
      el-table-column(
        prop="tipo",
        label="Tipo",
        :formatter="setTipoAtividadeProducao"
      )
      el-table-column(
        prop="numeroCabecas",
        label="Número de cabeças",
        :formatter="formatNumCabecas"
        :class="compararDestinacaoUsoImovel && compararDestinacaoUsoImovel.mudouEdificacoes && compararDestinacaoUsoImovel.mudouEdificacoes.mudouArea ? 'text': '' "
      )

  app-collapse-child(
    title="Benfeitorias",
    name="benfeitorias",
    v-if="destinacaoUsoImovel.benfeitorias && destinacaoUsoImovel.benfeitorias.length > 0"
  )
    el-table(
      :data="destinacaoUsoImovel.benfeitorias",
    )
      template(slot="empty")
        | Nenhuma benfeitoria cadastrada.
      el-table-column(
        prop="tipo",
        label="Tipo",
        :formatter="setTipoAtividadeProducao"
      )
      el-table-column(
        prop="area",
        :label= "(isBahia ? 'Área estimada' : 'Área')"
        :formatter="formatArea"
      )
</template>

<script>
import AppDisplay from '../AppDisplay'
import utils from '@/utils/utils'
import AppCollapseChild from '@/components/AppCollapseChild'
import AppCollapse from '@/components/AppCollapse'
import AppDivider from '@/components/AppDivider'
import ListagemDocumentos from './ListagemDocumentos'
import compararReticacoesDefault from '../../utils/pa/compararReticacoesDefault'

export default {

  components: {
    AppDisplay,
    AppCollapseChild,
    AppCollapse,
    AppDivider,
    ListagemDocumentos
  },

  props: {
    destinacaoUsoImovel: {
      type: Object,
      required: true
    },
    compararDestinacaoUsoImovel: {
      type: Object,
      default: compararReticacoesDefault.mudouDestinacaoUsoImovelDTODefault
    }
  },

  data () {
    return {
      destinacaoUsoImovelCollapse: ['0'],
      produtividade: null
    }
  },

  computed: {
    showListagem () {
      if ((this.destinacaoUsoImovel.culturasPermanentes && this.destinacaoUsoImovel.culturasPermanentes.length > 0) ||
          (this.destinacaoUsoImovel.culturasTemporarias && this.destinacaoUsoImovel.culturasTemporarias.length > 0) ||
          (this.destinacaoUsoImovel.criacoes && this.destinacaoUsoImovel.criacoes.length > 0) ||
          (this.destinacaoUsoImovel.benfeitorias && this.destinacaoUsoImovel.benfeitorias.length > 0)) {
        return true
      }
      return false
    },
    isBahia () {
      return process.env.ESTADO === 'ba'
    }
  },
  created () {
    if (this.destinacaoUsoImovel.culturasPermanentes && this.destinacaoUsoImovel.culturasPermanentes.length > 0) {
      this.destinacaoUsoImovelCollapse = 'culturasPermanentes'
    }
    if (this.destinacaoUsoImovel.culturasTemporarias && this.destinacaoUsoImovel.culturasTemporarias.length > 0) {
      this.destinacaoUsoImovelCollapse = 'culturasTemporarias'
    }
    if (this.destinacaoUsoImovel.criacoes && this.destinacaoUsoImovel.criacoes.length > 0) {
      this.destinacaoUsoImovelCollapse = 'criacoes'
    }
    if (this.destinacaoUsoImovel.benfeitorias && this.destinacaoUsoImovel.benfeitorias.length > 0) {
      this.destinacaoUsoImovelCollapse = 'benfeitorias'
    }

    this.setTotalAreaEmUso()
  },

  methods: {
    setTipoAtividadeProducao (prop) {
      if (prop?.descricao && prop.descricao !== '') {
        return prop.tipo === 'OUTROS'
          ? 'OUTROS - ' + prop.descricao : prop.descricao
      } else if (prop?.descTipo && prop.descTipo !== '') {
        return prop.tipo === 'OUTROS'
          ? 'OUTROS - ' + prop.descTipo : prop.descTipo
      } else {
        return prop?.tipoAtividadeProducao?.descricao || prop.tipo
      }
    },

    getAtividadesOutros (atividade) {
      if (atividade.tipo === null) return '-'
      if (atividade.tipo === 'APICULTURA') return 'Apicultura'
      if (atividade.tipo === 'AVICULTURA') return 'Avicultura'
      if (atividade.tipo === 'CUNICULTURA') return 'Cunicultura'
      if (atividade.tipo === 'FLORICULTURA') return 'Floricultura'
      if (atividade.tipo === 'FRUTICULTURA') return 'Fruticultura'
      if (atividade.tipo === 'OLERICULTURA') return 'Olericultura'
      if (atividade.tipo === 'BOVINOCULTURA') return 'Bovinocultura'
      return atividade.tipo
    },
    // TODO - caso necessário exibir o total da área em uso, converter a area das benfeitorias para hectare antes de somar
    setTotalAreaEmUso () {
      let areaEmUso = 0.0

      areaEmUso += this.destinacaoUsoImovel.culturasTemporarias && this.destinacaoUsoImovel.culturasTemporarias.length > 0 ? this.destinacaoUsoImovel.culturasTemporarias
        .map(culturaTemporaria => culturaTemporaria.area).reduce((area, culturaTemporaria) => area + culturaTemporaria) : 0

      areaEmUso += this.destinacaoUsoImovel.culturasPermanentes && this.destinacaoUsoImovel.culturasPermanentes.length > 0 ? this.destinacaoUsoImovel.culturasPermanentes
        .map(culturaPermanente => culturaPermanente.area).reduce((area, culturaPermanente) => area + culturaPermanente) : 0

      this.destinacaoUsoImovel.totalAreaEmUso = areaEmUso > 0 ? areaEmUso + ' hectare(s)' : undefined
    },

    formatterDecimal (value, precision) {
      return utils.format(value, { prefix: '', suffix: '', thousands: '.', decimal: ',', precision })
    },

    formatProdutividade (row) {
      if (row.descUnidadeProducao !== null) {
        return row.produtividade + ' ' + (row.descUnidadeProducao || row.tipoUnidadeProducao?.descricao)
      }
      const produtividade = this.formatterDecimal(row.produtividade, 4)
      return produtividade
    },

    formatAreaHectare (row) {
      return !row.area ? '-' : this.formatterDecimal(row.area, 4) + ' hectare(s)'
    },

    formatNumCabecas (row) {
      return row.numeroCabecas
    },

    formatArea (row) {
      return this.formatterDecimal(row.area, 4) + ' ' + row.tipoArea
    }
  }
}
</script>
<style lang="scss" scoped>
.margin-top {
  margin-top: 10px;
}
>>> .text .text{
    color: #ff0000 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/informacoesCadastro/InformacoesAtividades.vue